import { Constants } from "~/lib/constants";
import { SkillLevelIndicator } from "~/components/skills/SkillLevelIndicator";
import { SkillType } from "~/types/SkillLevel";
import { getSkillStageByLevel } from "~/utils/skills";

export const SkillLevelDashboard = ({
  skills,
  practiceSkill,
}: {
  skills: SkillType[];
  practiceSkill: (skillName?: SkillType["name"]) => void;
}) => {
  const isOdd = skills.length % 2 === 1;
  const topSkill = isOdd ? skills[0] : null;
  const remainingSkills = isOdd ? skills.slice(1) : skills;
  const skillPairs: SkillType[][] = [];
  for (let i = 0; i < remainingSkills.length; i += 2) {
    if (i + 1 < remainingSkills.length) {
      skillPairs.push([remainingSkills[i], remainingSkills[i + 1]]);
    } else {
      // Handle odd number of remaining skills (shouldn't happen with our logic, but just in case)
      skillPairs.push([remainingSkills[i]]);
    }
  }
  return (
    <div className="flex flex-col items-center gap-5">
      {topSkill && (
        <SkillLevelIndicator
          icon={(
            Constants.SKILLS[topSkill.name].stages as {
              [key: number]: { icon: (size?: number) => React.ReactNode };
            }
          )[getSkillStageByLevel(topSkill.level)].icon()}
          skill={topSkill}
          practiceSkill={practiceSkill}
          isComingSoon={topSkill.name === "Signals"}
        />
      )}

      {skillPairs.map((pair, rowIndex) => (
        <div
          key={`row-${rowIndex}`}
          className="flex flex-row justify-center items-center gap-10"
        >
          {pair.map((skill) => (
            <SkillLevelIndicator
              key={skill.name}
              icon={(
                Constants.SKILLS[skill.name].stages as {
                  [key: number]: { icon: (size?: number) => React.ReactNode };
                }
              )[getSkillStageByLevel(skill.level)].icon()}
              skill={skill}
              practiceSkill={practiceSkill}
              isComingSoon={skill.name === "Signals"}
            />
          ))}
        </div>
      ))}
    </div>
  );
};
